// 交易对手 - 简体中文
export default {
  loading: { text: "拼命加载中" },
  filters: {
    tag: "标签",
    currency: "币种",
    direction: "方向",
    selectTag: "请选择标签",
    selectCurrency: "请选择币种",
    selectDirection: "请选择方向",
    more: "更多",
    amountRange: "金额区间",
    minAmount: "最小金额",
    maxAmount: "最大金额",
  },
  table: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
    download: "下载",
    empty: "暂无数据",
    counterparty: "交易对手",
    totalValue: "交易金额",
    totalCount: "交易笔数",
    actions: "操作",
  },
  directionOptions: {
    ALL: "双向",
    INFLOW: "转入",
    OUTFLOW: "转出",
  },
};
